const { isEmpty } = require('lodash');

module.exports = {
  fieldsToStart: () => {
    return {
      startId: {
        label: '開始ID',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
    };
  },
};

